import React from 'react';
import { DialogTitle, DialogContent, DialogActions, DialogContentText, Button } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import { colors } from 'Constants/Colors';
import useUpdate from '../Hooks/useUpdate';

export default function ModalEdit({
  data = null,
  cancel = () => {},
  accept = () => {},
  allEmployees = [],
  setAllEmployees = () => {},
}) {
  const { t } = useTranslation();
  const { handleClick } = useUpdate({
    data,
    cancel,
    allEmployees,
    setAllEmployees,
  });
  return (
    <div className="col">
      <DialogTitle
        style={{
          fontWeight: 'bold',
          color: colors.BLACK,
          fontFamily: 'quicksand',
        }}
      >
        {t('Employee.ModifyStatus')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ fontFamily: 'metropolis' }}>{t('Employee.DialogMsg')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button style={{ fontFamily: 'quicksand' }} color="success" variant="outlined" onClick={cancel}>
          {t('Generic.Cancel')}
        </Button>
        <Button
          style={{ fontFamily: 'quicksand' }}
          color="success"
          onClick={async () => {
            await handleClick();
            accept();
          }}
          variant="contained"
        >
          {t('Generic.Accept')}
        </Button>
      </DialogActions>
    </div>
  );
}
